import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
var Config = require('../../../config');

class ModalPreRegisterIncident extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveIncident = this.saveIncident.bind(this);
		this.state = {
		    show: false,
		    caller:"",
		    incident_type:"",
		    incidents:[]
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(caller) {
		this.setState({ caller:caller,show: true,incident_type:""});
		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'incidents?option=incident_preregistro',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      incidents: response
		    });
		})
	}

	saveIncident(){
		
		if(this.isValidForm()){
			/*this.waiting_modal.handleShow('Generando...');*/
			var obj = this.state.caller;
			obj.incident_id = this.state.incident_type;
			fetch(Config.default.apiGateway.URL+'caller_actions_history/'+this.state.caller.id, {
			  method: 'PUT', // or 'PUT',
			  body: JSON.stringify(obj), // data can be `string` or {object}!
			  headers: new Headers({
			  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			  	'Accept': 'application/json',
			  	'Content-Type': 'application/json;charset=UTF-8'
			  })
			}).then(res => {
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result) {
						swal('¡Error!', result, 'error');
					});
				}})
			.then(response => {
		    	if(response !== undefined){
		    		if(this.state.caller.id !== undefined || this.state.caller !== null){
		    			fetch(Config.default.apiGateway.URL+'caller_actions_history?id='+this.state.caller.id+'&ip=&section=0&option=release ', {
					        method: 'PUT', // or 'PUT'
					        headers: new Headers({
					          'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
					          'Accept': 'application/json',
					          'Content-Type': 'application/json;charset=UTF-8'
					        })
					    }).then(res => {
					        if(res.ok){
					          return res.json();
					        }console.log(res)})
					      .catch(error => console.error('Error:', error))
					      .then(response => {
					        if(response !== undefined){
					        	this.setState({ show: false});
					    		this.props.refresh();
					         	
					        }
					    });
					  }else{
					  	this.setState({ show: false});
					    this.props.refresh();
					  }
			    		
		    	}
			})
			.catch(function(error) {
			  console.log('There has been a problem with your fetch operation: ' + error.message);
			});
		}else{
			swal('¡Error!', 'Campos Incompletos', 'error');
		}
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const ctrls = document.querySelectorAll('select');
	    let isFormValid = true;

	    ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		//console.log(refName+' is required');
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {
	        if(control !== null){
	            control.classList.add('error');
	        }
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
		        	control.classList.remove('error');
		    	}
	    	}
			res = true;
		}

		return res;
	}

	selectFieldHandle = (id, name, event, index, value) => {
		this.setState({[event.target.name]:event.target.value});
	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.moda_preregister_incident.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{margin:"10px"}}>
		        		<div className="col-xs-12">
		 					<div className="col-xs-2" >
		 						<span >{t('content.moda_preregister_incident.incident')}:</span>
		 					</div>
		 					<div className="col-xs-6">
		 						<select className="form-control" value={ this.state.incident_type }  required
								onChange={ this.selectFieldHandle.bind(null,"id","incident_type") } name="incident_type" id="incident_type">
								<option value="" disabled >Seleccionar...</option>
								{
									this.state.incidents.map(function(t,index) {
										return <option key={index}  value={t.id}>{t.name} </option>
									})
								}
								</select>
							</div>
						</div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveIncident}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
	      	</div>
		);
	}
}

export default translate('translations')(ModalPreRegisterIncident);